module.exports = __webpack_public_path__ + "static/media/logo_deepleaning1.6f647dd1.png";